// extracted by mini-css-extract-plugin
export default {"discountBanner":"mba","topheader":"nba","navleft":"oba","navflexelem":"pba","navright":"qba","fixedtop":"rba","abstop":"sba","subdesc":"tba","smallscreennav":"uba","nav_hidden":"vba","cancel_link":"wba","bottomnavcontainer":"xba","fixedbottom":"yba","animatedbottom":"zba","appear-bottom":"Aba","delayedbottom":"Bba","retakebtn":"Cba","long_banner":"Eba","nofixed":"Fba"};
    if(module.hot) {
      // 1714442371899
      var cssReload = require("../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  